import * as React from "react";
import { Button, Card, Stack, Typography } from "@mui/joy";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import { createAdminQuote } from "../api";
import AdminQuoteForm, { QuoteFormValues } from "../components/Admin/AdminQuoteForm";
import PageHero from "../components/common/PageHero";

export default function AdminQuoteCreatePage() {
  const navigate = useNavigate();
  const [saving, setSaving] = React.useState(false);

  const handleCreate = async (data: QuoteFormValues) => {
    setSaving(true);
    try {
      await createAdminQuote(data);
      navigate("/quotes");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Stack spacing={3}>
      <PageHero
        eyebrow="Daily reflections"
        title="Compose a new quote"
        description="Offer a heartfelt meditation that will brighten the dashboard hero for every devotee."
        actions={
          <Button
            component={RouterLink}
            to="/quotes"
            variant="outlined"
            color="neutral"
            startDecorator={<ArrowBackRoundedIcon />}
          >
            Back to library
          </Button>
        }
      />

      <Card
        variant="outlined"
        sx={{
          borderRadius: "xl",
          p: { xs: 2.5, md: 3 },
          gap: 2.5,
        }}
      >
        <Stack spacing={0.75}>
          <Typography level="title-md" sx={{ fontWeight: 700 }}>
            Share today’s meditation
          </Typography>
          <Typography level="body-sm" sx={{ color: "text.secondary", maxWidth: 520 }}>
            Thoughtful words guide the community’s sadhana. Keep it concise, compassionate, and true to the scriptures.
          </Typography>
        </Stack>

        <AdminQuoteForm onSubmit={handleCreate} submitLabel="Create quote" loading={saving} />
      </Card>
    </Stack>
  );
}
